module.exports = __webpack_public_path__ + "static/media/flag.e5a30d6d.svg";